import PolicyLayout from "@/components/PolicyLayout";

export default function WarrantyPage() {
  return (
    <PolicyLayout title="Warranty">
      <p>
        Pickle Wall™ is built with heavy-duty, professional-grade materials. If
        your unit arrives with a manufacturing defect, or fails under normal
        training use, reach out to us — we stand behind what we build and will
        work with you on a repair or replacement.
      </p>
      <p>
        Our full written warranty — including exact coverage length and terms —
        is currently being finalized and will be published here. Until then,
        every warranty claim is reviewed individually; email us with your order
        number and a description (and photos, if possible) of the issue.
      </p>
    </PolicyLayout>
  );
}
